export const adminCacheConfig: {
    endpoint: string | ((data: any) => string);
    method: string;
    bodyDep?: string[];
    baseUrlEnv?: string;
    paramDep?: string[];
}[] = [
    {
        endpoint: '/case-config-server/inbox/admin/fetch',
        method: 'POST',
        bodyDep: ['projectId'],
    },
    {
        endpoint: '/language-translation/fetch-languages',
        method: 'POST',
        baseUrlEnv: 'ALPHA_UI_CONFIG_SERVICE_URL',
        bodyDep: ['projectId'],
    },
];
